// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CaptureImageRequest/Content/Content/Request/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_CaptureImageRequest_Content_Content_Request($id: uuid!) {
  images_requests_by_pk(id: $id) {
    id
    status
  }
}

`